import React,{Component} from 'react';
import { Tab, Checkbox, Divider } from 'semantic-ui-react';

import {PackagingTypes} from '../../../utils/Constants'

export default class PackagingType extends Component{
    constructor(props){
        super(props);
        this.state={
            conveyorIDs:Object.keys(props.packagingTypes),
            currentTypeValues:{}
        };
        
    }
    componentDidMount(){
        this.updateCurrentTypeValues();
    }
    updateCurrentTypeValues(){
        let {conveyorIDs} = this.state;
        let {packagingTypes} = this.props;
        conveyorIDs.forEach((id) => {
            this.updateCurrentTypeValue(id,packagingTypes[id]);
        })
    }
    updateCurrentTypeValue(conveyorID,type){
        let {currentTypeValues} = this.state;
        currentTypeValues[conveyorID] = type;
        this.setState({currentTypeValues});
    }
    getPackagingTypeLabel(type){
        switch(type){
            case PackagingTypes.Neutral:
                return "Vit emballage";
            case PackagingTypes.Apotea:
                return "Apotea emballage";
            default:
                return "Okänd";
        }
    }
    onChange(event,{value},conveyorID){
        this.updateCurrentTypeValue(conveyorID,value);
        this.props.onChange(conveyorID,value);
    }
    renderRow(conveyorID, index){
        let {currentTypeValues} = this.state;
        return (
            <React.Fragment key={index}>
                <div className="PackagingTypeRow" key={index}>
                    <div>{`Maskin ${conveyorID}`}</div >
                    {Object.keys(PackagingTypes).map((typeKey,ix) => {
                        let type = PackagingTypes[typeKey]
                        return <Checkbox 
                                    key={ix} 
                                    className="PackagingTypeCheckbox"
                                    label={this.getPackagingTypeLabel(type)} 
                                    value={type} 
                                    checked={currentTypeValues[conveyorID] === type} 
                                    onChange={(event,data) => this.onChange(event,data,conveyorID)} 
                                    radio 
                                />
                    })}
                </div>
                <Divider/>
            </React.Fragment>

        );
    }
    render(){
        let {conveyorIDs} = this.state;
        return (
            <Tab.Pane className="PackagingTypeContainer">
                {conveyorIDs.map((conveyorID,ix) => {
                    return (
                        this.renderRow(conveyorID,ix)
                    );
                })}
            </Tab.Pane>
        );
    }
}